<template>
  <AskusFilter />
  <div class="list">
    <template v-if="isLoading">
      <vue-loading :loadingMessage="domainStore.translate('askus.message.loading-questions')" />
    </template>
    <template v-else>
      <AskusListContent :questions="questions" @openQuestion="openQuestion" />
    </template>

    <template v-if="!isLoading && questions.length == 0">
      <p class="text-center">{{ domainStore.translate('askus.message.no-questions-yet') }}</p>
    </template>

    <template v-if="pager.total_entries">
      <Paginator :rows="10" :totalRecords="pager.total_entries" @page="onPageChange($event)" />
    </template>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue';

import AskusFilter from '@/components/askus/AskusFilter.vue';
import AskusListContent from '@/components/askus/AskusListContent.vue';
import VueLoading from '@/components/general/Loading.vue';
import Paginator from 'primevue/paginator';

import { domainStore } from '@/store/domain-store';
import { askusStore } from '@/store/askus-store';

import { IAskusQuestion } from '@/models/askus.model';

export default defineComponent({
  //Prevents warning caused by the keep alive functionality.
  // Warnings included -> use of externious Props...etc
  inheritAttrs: false,
  name: 'AskusList',
  props: {
    askusid: {
      type: Number,
      required: true,
    },
  },
  components: {
    Paginator,
    AskusFilter,
    AskusListContent,
    VueLoading,
  },
  emits: ['openQuestion'],
  setup(props, context) {
    const isLoading = computed(() => {
      return askusStore.getState().isLoadingContent;
    });
    const questions = computed(() => {
      return askusStore.getState().question;
    });
    const pager = computed(() => {
      return askusStore.getState().pager;
    });

    function onPageChange(event) {
      askusStore.updateToPage(event.page + 1);
      askusStore.fetchQuestions();
    }

    function openQuestion(question, questionid) {
      context.emit('openQuestion', question, questionid);
    }

    return {
      domainStore,
      questions,
      pager,
      isLoading,
      onPageChange,
      openQuestion,
    };
  },
});
</script>

<style lang="scss" scoped>
th {
  font-weight: normal;
}
.title {
  color: #4b6bb3;
  font-weight: bold;
  min-width: 70%;
}
.question-row:hover {
  background-color: #f2f2f2;
  cursor: pointer;
}
label {
  display: inline;
  font-weight: bold;
  max-width: 100%;
}
</style>
